import { generateTrackingId } from "./utilities";

// ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
// Search Interaction ID

let searchInteractionId: string | undefined = undefined;
let successful: boolean = false;

export function getSearchInteractionId(): string | undefined {
  return searchInteractionId;
}

export function wasSearchInteractionSuccessful(): boolean {
  return successful;
}

export function updateSearchInteractionId(): void {
  // Requests a new Search Interaction ID, called when a user
  // opens the Search Dialog
  searchInteractionId = generateTrackingId();
  successful = false;
}

export function setSearchInteractionSuccessful(): void {
  successful = true;
}

export function clearSearchInteractionId(): void {
  // Clears the Search Interaction ID, called when a user
  // closes the Search Dialog
  searchInteractionId = undefined;
  successful = false;
}
